const RECEIPT_PDF = '/pdf/receipts.php';
const TICKET_PDF = '/pdf/tickets.php';
const INVOICE_PDF = '/pdf/invoice.php';
const BOOKING_PDF = '/pdf/tickets_booking.php';

const PDF_API = {RECEIPT_PDF, TICKET_PDF, INVOICE_PDF, BOOKING_PDF};

export default PDF_API;
